import SwipeSlider from './SwipeSlider';
export default SwipeSlider;

//# sourceMappingURL=index.js.map